import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";


const AuthGuard = () => {
  const {isAuthenticated} =  useAuth();
  return isAuthenticated ? <Outlet /> : <Navigate to="/signin" replace />;
};
export const CheckAuth = ()=>{
  const {isAuthenticated} =  useAuth();
  return  isAuthenticated ? <Navigate to="/" replace /> :  <Outlet />
}
export default AuthGuard;